import { BsModalService } from 'ngx-bootstrap/modal'
import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'

import { Component, Input, OnInit } from '@angular/core'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { UntilDestroy } from '@ngneat/until-destroy'
import { Store } from '@ngrx/store'

import { EmailLog } from '../../email-log/email-log'
import { emailLogActions } from '../../email-log/email-log.actions'
import { emailLogSelectors } from '../../email-log/email-log.selectors'
import { EmailLogShowModalComponent } from '../../email-log/show-modal/show.component'
import { map } from 'rxjs/operators'

@UntilDestroy()
@Component({
  selector: 'sale-email-logs-tab',
  templateUrl: './show.component.html'
})
export class SaleEmailLogsTabComponent implements OnInit {
  @Input() saleId: number

  public emailLogs$: Observable<EmailLog[]>

  constructor(
    private store: Store<AppState>,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.store.dispatch(
      emailLogActions.fetchMany({
        params: RequestQueryBuilder.create({
          join: [{ field: 'emailTemplate' }],
          search: {
            saleId: this.saleId
          }
        })
      })
    )

    this.emailLogs$ = this.store.select(emailLogSelectors.selectAll).pipe(
      map((emailLogs) => {
        return emailLogs
          .filter((e) => e.saleId == this.saleId)
          .sort((a, b) => (a.id > b.id ? -1 : 1))
      })
    )
  }

  public onClickRow(emailLog: EmailLog): void {
    this.modalService.show(EmailLogShowModalComponent, {
      initialState: {
        emailLogId: emailLog.id
      },
      class: 'modal-xl modal-dialog-scrollable'
    })
  }
}
